import './App.css';
import HeaderNavbar from './components/Navbar';
import Image1 from './images/image1.png';
import Image3 from './images/image3.png';
import PlayStoreButton from './images/play-store-button.png';
import AppStoreButton from './images/app-store-button.png';
import Budget from './images/budget.jpg';
import BudgetIcon from './images/budget_icon.png';
import RTPIcon from './images/rtp_icon.png';
import RTP from './images/rtp.jpg';
import SplitBill from './images/split_bill.jpg';
import SplitBillIcon from './images/splitbill_icon.png';
import Transfer from './images/transfer.jpg';
import TransferIcon from './images/transfer icon.png';
import LinkedBankIcon from './images/linked bank.png';
import LinkedBank from './images/linked bank.jpg';
import PeekBalanceIcon from './images/peekbalance.png';
import PeekBalance from './images/peek_balance.jpg';
import PaymentPurcahse from './images/payment purchase.jpg';
import PaymentPurchaseIcon from './images/payment-purchase icon.png';
import LinkedEWalletIcon from './images/ewallet icon.png';
import LinkedEWallet from './images/linked e wallet.jpg';
import QrisIcon from './images/qris icon.png';
import Qris from './images/qr.jpeg';
import { Button } from 'flowbite-react';
import { FeatureCard } from './components/FeatureCard';
import { Footer } from './components/Footer';
import Wave from 'react-wavify';
import { motion, useInView, useScroll } from 'framer-motion';
import { useRef } from 'react';
import Logo from './images/logo_izzyfin.png';

function App() {
  const { scrollYProgress } = useScroll();

  return (
    <>
      <HeaderNavbar />
      <motion.div
        className="progress-bar"
        style={{ scaleX: scrollYProgress }}
      />
      <SectionOne />
      <SectionTwo />
      <SectionThree />
      <SectionFour />
      <Action />
      <Wave fill="url(#gradient)" className='z-[-1] fixed bottom-0' >
        <defs>
          <linearGradient id="gradient" gradientTransform="rotate(90)">
            <stop offset="10%" stopColor="#3282B8" />
            <stop offset="90%" stopColor="#40A3E0" />
          </linearGradient>
        </defs>
      </Wave>
      <Footer />
    </>
  );
}

function SectionOne() {
  return (
    <section id='home' className="mb-24 ">
      <div className="grid max-w-screen-xl lg:max-w-screen-2xl pl-4 py-8 mx-auto lg:gap-8 xl:gap-0 lg:py-0 lg:grid-cols-12">
        <div className="flex flex-col justify-center items-center lg:block lg:ml-10 lg:place-self-center lg:col-span-7">
          <motion.h1
            className="max-w-2xl mb-4 text-4xl font-extrabold tracking-tight leading-none md:text-5xl xl:text-6xl dark:text-white"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >We are truly The Real Open Banking!</motion.h1>
          <motion.p
            className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >With IzzyFin, you can access all your account in many different banks.
            You don’t need to install or open many banking apps anymore. It is all in IzzyFin.
          </motion.p>
          <motion.div
            className='flex gap-5'
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.a
              href="https://www.apple.com/id/app-store/" className="inline-flex items-center justify-center text-base font-medium text-center text-black rounded-lg bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 dark:focus:ring-primary-90"
              whileHover={{ scale: 1.1 }}
              transition={{ type: "spring", stiffness: 400, damping: 10 }}
            >
              <img src={AppStoreButton} className='w-[150px] hover:w-[155px]' alt='app store button' />
            </motion.a>
            <motion.a
              href="https://play.google.com/store/games?hl=id&gl=US" className="inline-flex items-center justify-center text-base font-medium text-center text-black rounded-lg bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 dark:focus:ring-primary-900"
              whileHover={{ scale: 1.1 }}
              transition={{ type: "spring", stiffness: 400, damping: 10 }}
            >
              <img src={PlayStoreButton} className='w-[150px] hover:w-[155px]' alt='playstore buttone' />
            </motion.a>
          </motion.div>
        </div>
        <motion.div
          className="hidden lg:mt-0 lg:col-span-5 lg:flex lg:justify-end lg:align-middle"
          animate={{
            x: 200,
            rotate: -15
          }}
          transition={{ type: "spring", stiffness: 20 }}
        >
          <img src={Image3} width={'100%'} alt="mockup" />
        </motion.div>
      </div>
    </section >
  );
}

function SectionTwo() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true })
  return (
    <section id='sectionTwo' ref={ref} className="my-40 min-h-96" style={{
      transform: isInView ? "none" : "translateX(-200px)",
      opacity: isInView ? 1 : 0,
      transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s"
    }}>
      <div className="flex flex-col justify-center item-center lg:grid max-w-screen-xl lg:max-w-screen-2xl pl-4 py-8 mx-auto lg:gap-8 xl:gap-0 lg:py-0 lg:grid-cols-12">
        <div
          className="flex justify-center lg:mt-0 lg:col-span-5 lg:flex lg:justify-center"
        >
          <img src={Image1} alt="im" />
        </div>
        <motion.div
          className="flex flex-col justify-center items-center lg:col-span-7"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
        >
          <h1 className="max-w-2xl mb-4 text-4xl font-extrabold tracking-tight leading-none md:text-5xl xl:text-6xl dark:text-white">All assets in one page!</h1>
          <div className='mx-10'>
            <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">You can now link your bank account from many different banks to Izzyfin. In doing so, you will be able to see all your bank account balance from a single page.</p>
          </div>
          <div className='flex gap-5'>
            <Button>Learn More</Button>
          </div>
        </motion.div>
      </div>
    </section>
  )
}

function SectionThree() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: false })
  return (
    <section id='feature' ref={ref} className="lg:m-10" style={{
      transform: isInView ? "none" : "translateY(200px)",
      opacity: isInView ? 1 : 0,
      transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s"
    }}>
      <div className='flex flex-col justify-center items-center my-10'>
        <h1 className="max-w-2xl mb-4 text-4xl font-extrabold tracking-tight leading-none md:text-5xl xl:text-6xl dark:text-white">Feature</h1>
        <span className="max-w-2xl mb-4 text-xl tracking-tight leading-none md:text-3xl xl:text-3xl dark:text-white">Semua Fitur Untuk memudahkan anda</span>
      </div>
      <div className='flex flex-col lg:flex-row lg:flex-wrap lg:justify-center lg:gap-3 lg:gap-y-10  gap-10 p-10 lg:p-0'>
        <FeatureCard title={'Budget'} subtitle={'pantau pengeluarang yang dilakuka'} icon={BudgetIcon} image={Budget} />
        <FeatureCard title={'Request To Pay'} subtitle={'kirim pesan permintaan uang'} icon={RTPIcon} image={RTP} />
        <FeatureCard title={'Split Bill'} subtitle={'berbagi tagihan bayar dengan split bill'} icon={SplitBillIcon} image={SplitBill} />
        <FeatureCard title={'Transfer'} subtitle={'transfer ke bank clearing atau non clearing'} icon={TransferIcon} image={Transfer} />
        <FeatureCard title={'Linked Bank'} subtitle={'daftarkan akun bank milik anda'} icon={LinkedBankIcon} image={LinkedBank} />
        <FeatureCard title={'Peek Balance'} subtitle={'intip saldo rekening anda'} icon={PeekBalanceIcon} image={PeekBalance} />
        <FeatureCard title={'Payment Purchase'} subtitle={'bayar tagihan atau isi pulsa'} icon={PaymentPurchaseIcon} image={PaymentPurcahse} />
        <FeatureCard title={'Linked E-Wallet'} subtitle={'daftarkan E-wallet milik anda'} icon={LinkedEWalletIcon} image={LinkedEWallet} />
        <FeatureCard title={'QRIS'} subtitle={'bayar dengan QRIS'} icon={QrisIcon} image={Qris} />
      </div>
    </section>
  )
}

function SectionFour() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: false })
  return (
    <div
      ref={ref}
      className="mx-auto w-full max-w-screen-xl p-4 py-6 lg:py-8"
      style={{
        transform: isInView ? "none" : "translateY(200px)",
        opacity: isInView ? 1 : 0,
        transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s"
      }}
    >
      <div className="md:flex md:justify-between">
        <div className="mb-6 md:mb-0">
          <a href="https://izzyfin.com" className="flex items-center">
            <img src={Logo} className="h-16 me-3" alt="FlowBite Logo" />
          </a>
        </div>
      </div>
      <div className='flex gap-24 m-10 mb-52'>
        <div>
          <h3 className='text-lg font-bold bg-gradient-to-br from-cyan-500 to-blue-500 text-transparent bg-clip-text'>Kantor Pusat</h3>
          <span className='text-gray-500'>International Financial Centre
            <br />Tower 2 - 15th Floor
            <br />Jl. Jenderal Sudirman Kav. 22-23,
            Jakarta 12920, Indonesia.</span>
        </div>
        <div className='flex flex-col gap-4'>
          <h3 className='text-lg font-bold bg-gradient-to-br from-cyan-500 to-blue-500 text-transparent bg-clip-text'>
            Hubungi Kami
          </h3>
          <a href='mailto:contact@izzyfin.com' className='text-gray-500 flex flex-row gap-5 hover:text-gray-900 dark:hover:text-white'>
            <svg className='w-6 h-6' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="mail"><path fill="currentColor" d="M16,14.81,28.78,6.6A3,3,0,0,0,27,6H5a3,3,0,0,0-1.78.6Z"></path><path fill="currentColor" d="M16.54,16.84h0l-.17.08-.08,0A1,1,0,0,1,16,17h0a1,1,0,0,1-.25,0l-.08,0-.17-.08h0L2.1,8.26A3,3,0,0,0,2,9V23a3,3,0,0,0,3,3H27a3,3,0,0,0,3-3V9a3,3,0,0,0-.1-.74Z"></path></svg>
            <span>
              Email
            </span>
          </a>
          <a href='https://api.whatsapp.com/send?phone=6287700966866&text=Halo%20IzzyCare!' target='_blank' rel="noreferrer" className='text-gray-500 flex flex-row gap-5 hover:text-gray-900 dark:hover:text-white'>
            <svg className='w-6 h-6' fill='currentColor' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 737.509 740.824" id="whatsapp"><path fillRule="evenodd" d="M630.056 107.658C560.727 38.271 468.525.039 370.294 0 167.891 0 3.16 164.668 3.079 367.072c-.027 64.699 16.883 127.855 49.016 183.523L0 740.824l194.666-51.047c53.634 29.244 114.022 44.656 175.481 44.682h.151c202.382 0 367.128-164.689 367.21-367.094.039-98.088-38.121-190.32-107.452-259.707m-259.758 564.8h-.125c-54.766-.021-108.483-14.729-155.343-42.529l-11.146-6.613-115.516 30.293 30.834-112.592-7.258-11.543c-30.552-48.58-46.689-104.729-46.665-162.379C65.146 198.865 202.065 62 370.419 62c81.521.031 158.154 31.81 215.779 89.482s89.342 134.332 89.311 215.859c-.07 168.242-136.987 305.117-305.211 305.117m167.415-228.514c-9.176-4.591-54.286-26.782-62.697-29.843-8.41-3.061-14.526-4.591-20.644 4.592-6.116 9.182-23.7 29.843-29.054 35.964-5.351 6.122-10.703 6.888-19.879 2.296-9.175-4.591-38.739-14.276-73.786-45.526-27.275-24.32-45.691-54.36-51.043-63.542-5.352-9.183-.569-14.148 4.024-18.72 4.127-4.11 9.175-10.713 13.763-16.07 4.587-5.356 6.116-9.182 9.174-15.303 3.059-6.122 1.53-11.479-.764-16.07-2.294-4.591-20.643-49.739-28.29-68.104-7.447-17.886-15.012-15.466-20.644-15.746-5.346-.266-11.469-.323-17.585-.323-6.117 0-16.057 2.296-24.468 11.478-8.41 9.183-32.112 31.374-32.112 76.521s32.877 88.763 37.465 94.885c4.587 6.122 64.699 98.771 156.741 138.502 21.891 9.45 38.982 15.093 52.307 19.323 21.981 6.979 41.983 5.994 57.793 3.633 17.628-2.633 54.285-22.19 61.932-43.616 7.646-21.426 7.646-39.791 5.352-43.617-2.293-3.826-8.41-6.122-17.585-10.714" clipRule="evenodd"></path></svg>
            <span>
              WhatsApp
            </span>
          </a>
          <a href='https://instagram.com/izzyfin.id' target='_blank' rel="noreferrer" className='text-gray-500 flex flex-row gap-5 hover:text-gray-900 dark:hover:text-white'>
            <svg className='w-6 h-6' fill='currentColor' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" id="instagram"><path d="M18.946 6.29a6.606 6.606 0 0 0-.418-2.185 4.412 4.412 0 0 0-1.039-1.594 4.412 4.412 0 0 0-1.594-1.039 6.606 6.606 0 0 0-2.184-.418C12.75 1.01 12.444 1 10 1s-2.75.01-3.71.054a6.606 6.606 0 0 0-2.185.418A4.412 4.412 0 0 0 2.51 2.511a4.412 4.412 0 0 0-1.039 1.594 6.606 6.606 0 0 0-.418 2.184C1.01 7.25 1 7.556 1 10s.01 2.75.054 3.71a6.606 6.606 0 0 0 .418 2.185 4.412 4.412 0 0 0 1.039 1.594 4.411 4.411 0 0 0 1.594 1.039 6.606 6.606 0 0 0 2.184.418C7.25 18.99 7.556 19 10 19s2.75-.01 3.71-.054a6.606 6.606 0 0 0 2.185-.418 4.602 4.602 0 0 0 2.633-2.633 6.606 6.606 0 0 0 .418-2.184C18.99 12.75 19 12.444 19 10s-.01-2.75-.054-3.71zm-1.62 7.347a4.978 4.978 0 0 1-.31 1.67 2.98 2.98 0 0 1-1.708 1.709 4.979 4.979 0 0 1-1.671.31c-.95.043-1.234.052-3.637.052s-2.688-.009-3.637-.052a4.979 4.979 0 0 1-1.67-.31 2.788 2.788 0 0 1-1.036-.673 2.788 2.788 0 0 1-.673-1.035 4.978 4.978 0 0 1-.31-1.671c-.043-.95-.052-1.234-.052-3.637s.009-2.688.052-3.637a4.979 4.979 0 0 1 .31-1.67 2.788 2.788 0 0 1 .673-1.036 2.788 2.788 0 0 1 1.035-.673 4.979 4.979 0 0 1 1.671-.31c.95-.043 1.234-.052 3.637-.052s2.688.009 3.637.052a4.979 4.979 0 0 1 1.67.31 2.788 2.788 0 0 1 1.036.673 2.788 2.788 0 0 1 .673 1.035 4.979 4.979 0 0 1 .31 1.671c.043.95.052 1.234.052 3.637s-.009 2.688-.052 3.637zM10 5.378A4.622 4.622 0 1 0 14.622 10 4.622 4.622 0 0 0 10 5.378zM10 13a3 3 0 1 1 3-3 3 3 0 0 1-3 3zm5.884-7.804a1.08 1.08 0 1 1-1.08-1.08 1.08 1.08 0 0 1 1.08 1.08z" transform="translate(-1 -1)"></path></svg>
            <span>
              Instagram
            </span>
          </a>
        </div>
      </div>
    </div>
  )
}

function Action() {
  return (
    <motion.div
      animate={{ x: [0, 100, 0] }}
      transition={{ type: "spring", stiffness: 100 }}
    >
      <motion.a
        href='#home'
        whileHover={{ scale: 1.1 }}
        transition={{ type: "spring", stiffness: 400, damping: 10 }}
        className="rounded-full fixed bottom-24 right-8 z-[90] border-2 border-white">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 16 16" id="chevron"><path fill="#2D76A4" d="M16 8c0-4.4-3.6-8-8-8S0 3.6 0 8s3.6 8 8 8 8-3.6 8-8zM4.4 10.8L3 9.4l5-5 5 5-1.4 1.4L8 7.2l-3.6 3.6z"></path></svg>
      </motion.a>
      <motion.a
        href='https://api.whatsapp.com/send?phone=6287700966866&text=Halo%20IzzyCare!'
        target='_blank'
        whileHover={{ scale: 1.1 }}
        transition={{ type: "spring", stiffness: 400, damping: 10 }}
        className="rounded-full fixed bottom-8 right-8 z-[90] border-2 border-white text-white">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 48 48" id="whatsapp"><rect width="48" height="48" fill="#0DC143" rx="24"></rect><path fill="#fff" d="M34.7507 13.2115C32.1777 10.5628 28.621 9.125 24.9885 9.125C17.2696 9.125 11.0642 15.4061 11.1399 23.0493C11.1399 25.4709 11.821 27.8169 12.9561 29.9358L10.9885 37.125L18.3291 35.2331C20.3723 36.3682 22.6426 36.898 24.9128 36.898C32.5561 36.898 38.7615 30.6169 38.7615 22.9736C38.7615 19.2655 37.3237 15.7845 34.7507 13.2115ZM24.9885 34.552C22.9453 34.552 20.902 34.0223 19.1615 32.9628L18.7074 32.7358L14.3183 33.8709L15.4534 29.5574L15.1507 29.1034C11.821 23.7304 13.4101 16.6169 18.8588 13.2872C24.3074 9.95743 31.3453 11.5466 34.675 16.9953C38.0047 22.4439 36.4156 29.4818 30.9669 32.8115C29.2264 33.9466 27.1074 34.552 24.9885 34.552ZM31.648 26.152L30.8156 25.7736C30.8156 25.7736 29.6047 25.2439 28.848 24.8655C28.7723 24.8655 28.6966 24.7899 28.621 24.7899C28.3939 24.7899 28.2426 24.8655 28.0912 24.9412C28.0912 24.9412 28.0156 25.0169 26.9561 26.2277C26.8804 26.3791 26.7291 26.4547 26.5777 26.4547H26.502C26.4264 26.4547 26.275 26.3791 26.1993 26.3034L25.821 26.152C24.9885 25.7736 24.2318 25.3196 23.6264 24.7142C23.475 24.5628 23.248 24.4115 23.0966 24.2601C22.5669 23.7304 22.0372 23.125 21.6588 22.4439L21.5831 22.2926C21.5074 22.2169 21.5074 22.1412 21.4318 21.9899C21.4318 21.8385 21.4318 21.6872 21.5074 21.6115C21.5074 21.6115 21.8101 21.2331 22.0372 21.0061C22.1885 20.8547 22.2642 20.6277 22.4156 20.4764C22.5669 20.2493 22.6426 19.9466 22.5669 19.7196C22.4912 19.3412 21.5831 17.298 21.3561 16.8439C21.2047 16.6169 21.0534 16.5412 20.8264 16.4655H20.5993C20.448 16.4655 20.221 16.4655 19.9939 16.4655C19.8426 16.4655 19.6912 16.5412 19.5399 16.5412L19.4642 16.6169C19.3128 16.6926 19.1615 16.8439 19.0101 16.9196C18.8588 17.0709 18.7831 17.2223 18.6318 17.3736C18.102 18.0547 17.7993 18.8872 17.7993 19.7196C17.7993 20.325 17.9507 20.9304 18.1777 21.4601L18.2534 21.6872C18.9345 23.125 19.8426 24.4115 21.0534 25.5466L21.3561 25.8493C21.5831 26.0764 21.8101 26.2277 21.9615 26.4547C23.5507 27.8169 25.3669 28.8007 27.4101 29.3304C27.6372 29.4061 27.9399 29.4061 28.1669 29.4818C28.3939 29.4818 28.6966 29.4818 28.9237 29.4818C29.302 29.4818 29.7561 29.3304 30.0588 29.1791C30.2858 29.0277 30.4372 29.0277 30.5885 28.8764L30.7399 28.725C30.8912 28.5736 31.0426 28.498 31.1939 28.3466C31.3453 28.1953 31.4966 28.0439 31.5723 27.8926C31.7237 27.5899 31.7993 27.2115 31.875 26.8331C31.875 26.6818 31.875 26.4547 31.875 26.3034C31.875 26.3034 31.7993 26.2277 31.648 26.152Z"></path></svg>
      </motion.a>
    </motion.div>
  );
}

export default App;
